<ng-container>

	<mat-card
		[ngStyle]="_visible()" class="patter-table panel">

		<mat-card-content [ngStyle]="styleSize(10 + this.size[0] + 'px')" class="panel-content" fxLayout="row">
			<div cdkDragHandle></div>

			<div fxLayout="column">
				<mat-select (selectionChange)="changeName();" [(value)]="name" style="font-weight:900">
					<mat-option value="ミート率"><span translate>ミート率</span></mat-option>
					<mat-option value="トータル"><span translate>トータル</span></mat-option>
					<mat-option value="キャリー"><span translate>キャリー</span></mat-option>
					<mat-option value="ヘッドスピード"><span translate>ヘッドスピード</span></mat-option>
					<mat-option value="ボール初速"><span translate>ボール初速</span></mat-option>
					<mat-option value="バックスピン"><span translate>バックスピン</span></mat-option>
					<mat-option value="サイドスピン"><span translate>サイドスピン</span></mat-option>
					<mat-option value="打ち出し角"><span translate>打ち出し角</span></mat-option>
					<mat-option value="ブロー角"><span translate>ブロー角</span></mat-option>
					<mat-option value="ヘッド軌道"><span translate>ヘッド軌道</span></mat-option>
					<mat-option value="フェイス角"><span translate>フェイス角</span></mat-option>
				</mat-select>
				<ngx-charts-line-chart
					[autoScale]="autoScale"
					[ngClass]="modename"
					[ngStyle]="modestyle"
					[results]="dataSource"
					[scheme]="colorScheme"
					[view]="size"
					[xAxisLabel]="xAxisLabel"
					[xAxisTickFormatting]="xAxisFormat"
					[yAxisLabel]="yAxisLabel"
					[yScaleMax]="yScaleMin"
					[yScaleMin]="yScaleMax"
					roundDomains="true"
					showXAxisLabel="false"
					showYAxisLabel="true"
					tooltipDisabled="true"
					xAxis="true"
					yAxis="true">
				</ngx-charts-line-chart>
			</div>

			<ng-template #noData>
				<mat-card style="background-color:#cdcdcd;">
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>

</ng-container>


